import { StyleSheet } from 'react-native';
import type { StylesMap } from 'types';

const styles: StylesMap = {
    container: {
        height: 30,
        width: 50
    },
    popupContainer: {
        position: 'absolute',
        left: '50%',
        bottom: 0
    }
};

export default StyleSheet.create(styles);
